var menu = $("#back-to-top").hide();
$(window).scroll(function(){

  if($(window).scrollTop() >= 800 ){
       menu.show();

  } else {
     menu.hide();
  }
});